import React, {useMemo} from "react";
import {useSelector} from "react-redux";
import {ReportLayout} from "./layout";
import {DropdownSlicer, ListSlicer} from "./slicers";
import useSlicers, {MONTH_OPTIONS} from "./slicer-state";
import useReport from "./use-report";
import {build_filters, events_text, WEEK_DAYS} from "./utils";

/** @module Pages/Reports/Calendario */

/**
 * Matriz del Power BI: filas = Semana (WEEKNUM del año), columnas = Día semana, valor = medida
 * "Eventos". Los días con visitas se pintan de verde (medida "formato").
 */
const CalendarMonth = ({month}) => {
    const people = new Set();
    month.weeks.forEach((w) => w.days.forEach((d) => d && d.events.forEach((e) => people.add(e.rut))));
    const with_persona = people.size > 1;

    return (
        <div className="pbi-matrix">
            <div className="pbi-matrix__title">{month.label}</div>
            <div className="pbi-matrix__scroll">
                <table>
                    <colgroup>
                        <col className="pbi-matrix__week-col"/>
                        {WEEK_DAYS.map((d) => <col key={d} className={d === "do." ? "pbi-matrix__sunday-col" : "pbi-matrix__day-col"}/>)}
                    </colgroup>
                    <thead>
                    <tr>
                        <th>Semana</th>
                        {WEEK_DAYS.map((d) => <th key={d} className={d === "do." ? "is-sunday" : ""} title={d}>{d}</th>)}
                    </tr>
                    </thead>
                    <tbody>
                    {month.weeks.map((week) => (
                        <tr key={week.index}>
                            <th>{week.index}</th>
                            {week.days.map((day, i) => {
                                const sunday = i === 6;
                                if (!day) return <td key={i} className={sunday ? "is-sunday" : ""}/>;
                                const text = events_text(day, with_persona);
                                return (
                                    <td key={i} title={text}
                                        className={`${day.events.length ? "has-events" : ""} ${sunday ? "is-sunday" : ""}`}>
                                        {sunday ? null : text}
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

/**
 * Página "Calendario" del Power BI: segmentadores de Año y Nombres completos arriba, Mes debajo y
 * la matriz semanal.
 */
const ReportCalendario = () => {
    const {token} = useSelector((state) => state.users_module.login.data) || null;
    const {slicers, set, yearOptions} = useSlicers(token);
    const filters = useMemo(() => build_filters({...slicers, centro: null}), [slicers]);
    const {data, loading, error} = useReport(token, "calendario", filters);

    return (
        <ReportLayout title="Calendario" token={token} body={{type: "calendario", filters}}
                      loading={loading} error={error}>
            <div className="pbi-page pbi-page--calendario">
                <div className="pbi-page__row">
                    <ListSlicer title="Año" options={yearOptions} value={slicers.year} onChange={set("year")} horizontal/>
                    <DropdownSlicer title="Nombres completos" field="nombre" token={token}
                                    value={slicers.nombre} onChange={set("nombre")} showHeader={false}/>
                </div>
                <ListSlicer title="Mes" options={MONTH_OPTIONS} value={slicers.month} onChange={set("month")} horizontal/>
                {data && data.months ? (
                    data.months.length ? data.months.map((m) => <CalendarMonth key={`${m.year}-${m.month}`} month={m}/>)
                        : <div className="pbi-matrix pbi-table__empty">No hay datos para los filtros seleccionados</div>
                ) : null}
            </div>
        </ReportLayout>
    );
};

export default ReportCalendario;
